export const strings = {
  NAME: "Login Form",
  DESCRIPTION: "Login Form",
} as const;
